var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"content-notice",class:_vm.statusClass},_vm._l((_vm.list),function(item,index){return _c('li',{key:`notice-item${index}`,domProps:{"innerHTML":_vm._s(item)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }